import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { isEmptyData } from '../../../utils/helper';
import { setProducts } from '../../../store/reducers/product';
import { useDispatch } from 'react-redux';

const Search = () => {
	const dispatch = useDispatch();
	const [query, setQuery] = useState('');
	const inputRef = useRef(null);
	const timeoutRef = useRef(null);

	const handleChange = (value) => {
		setQuery(value);

		// clear timeout sebelumnya
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		if (!isEmptyData(value)) {
			// set timeout baru
			timeoutRef.current = setTimeout(() => {
				dispatch(
					setProducts({
						keyword: value,
					}),
				);
			}, 500);
		} else {
			dispatch(
				setProducts({
					keyword: value,
				}),
			);
		}
	};

	const handleCloseSearch = () => {
		setQuery('');
		dispatch(
			setProducts({
				keyword: null,
			}),
		);
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
	};

  useEffect(() => {
    dispatch(setProducts({
      keyword: null
    }))
  }, [])
  

	return (
		<>
			<div className='w-full max-w-3xl p-4'>
				<div id='homepage_search' className='flex gap-2 items-center w-full rounded-full px-2.5 py-1.5 bg-white border border-solid border-gray-300 shadow-[0px_0px_22px_0px_#0000001A]' to='/ufood-x/search'>
					<MagnifyingGlassIcon className={`h-4 w-4 text-gray-600`} strokeWidth={3} />
					<div className='flex w-full items-center'>
						<input ref={inputRef} type='text' value={query} onChange={(e) => handleChange(e.target.value)} placeholder='Mau cari makanan apa?' className='w-full max-h-6 !bg-white text-xs placeholder:text-xs !p-0 !m-0' />
						{!isEmptyData(query) && <XCircleIcon onClick={() => handleCloseSearch()} className='h-4 w-auto text-gray-500' />}
					</div>
				</div>
			</div>
		</>
	);
};

export default Search;
